import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconStagedOrders: React.FC<IconProps> = ({
  size = 16,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M14.3 8.60989V5.74999C14.3 5.66824 14.2781 5.58829 14.2358 5.51839L11.7982 1.45474C11.6775 1.2555 11.5076 1.09064 11.3049 0.975984C11.1021 0.861326 10.8733 0.80072 10.6403 0.799988H4.45975C4.22674 0.800698 3.99783 0.861341 3.79503 0.976086C3.59223 1.09083 3.42236 1.25582 3.30175 1.45519L0.86425 5.51839C0.822087 5.58827 0.799883 5.66837 0.80005 5.74999V12.95C0.80005 13.6944 1.4056 14.3 2.15005 14.3H8.60995C9.30535 14.8617 10.1885 15.2 11.15 15.2C13.3834 15.2 15.2 13.3833 15.2 11.15C15.2 10.1885 14.8618 9.30529 14.3 8.60989ZM8.00005 1.69999H10.6403C10.7977 1.69999 10.9457 1.78399 11.0266 1.91839L13.0552 5.29999H8.00005V1.69999ZM4.0735 1.91884C4.11369 1.85228 4.17033 1.79718 4.23798 1.75885C4.30562 1.72053 4.382 1.70025 4.45975 1.69999H7.10005V5.29999H2.0449L4.0735 1.91884ZM1.70005 12.95V6.19999H13.4V7.78474C12.7349 7.33763 11.9515 7.0992 11.15 7.09999C8.9167 7.09999 7.10005 8.91664 7.10005 11.15C7.09926 11.9514 7.33769 12.7349 7.7848 13.4H2.15005C1.9018 13.4 1.70005 13.1982 1.70005 12.95ZM11.15 14.3C9.41335 14.3 8.00005 12.8867 8.00005 11.15C8.00005 9.41329 9.41335 7.99999 11.15 7.99999C12.8867 7.99999 14.3 9.41329 14.3 11.15C14.3 12.8867 12.8867 14.3 11.15 14.3ZM10.7 12.95C10.6409 12.9501 10.5824 12.9384 10.5278 12.9158C10.4732 12.8932 10.4236 12.86 10.3819 12.8181L9.0319 11.4681C8.8561 11.2923 8.8561 11.0076 9.0319 10.8318C9.2077 10.656 9.4924 10.656 9.6682 10.8318L10.7 11.8637L12.6319 9.93184C12.8077 9.75604 13.0924 9.75604 13.2682 9.93184C13.444 10.1076 13.444 10.3923 13.2682 10.5681L11.0182 12.8181C10.9765 12.86 10.9269 12.8932 10.8723 12.9158C10.8177 12.9384 10.7592 12.9501 10.7 12.95ZM5.30005 8.44999H3.50005C3.25135 8.44999 3.05005 8.24869 3.05005 7.99999C3.05005 7.75129 3.25135 7.54999 3.50005 7.54999H5.30005C5.54875 7.54999 5.75005 7.75129 5.75005 7.99999C5.75005 8.24869 5.54875 8.44999 5.30005 8.44999Z" fill="currentColor"/>
  </svg>
);

export default IconStagedOrders;
